import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getTrailPage } from "@/_pages/single-trail/api";
import type { TrailPageType } from "@/_pages/single-trail/model";
import { SingleTrailPage } from "@/_pages/single-trail/ui";

type Params = {
  slug: string;
};

type PageProps = {
  cms: TrailPageType;
};

const Page = (props: PageProps) => {
  const { cms } = props;

  return <SingleTrailPage trail={cms} />;
};

export const getServerSideProps: GetServerSideProps<{}, Params> = async (
  context,
) => {
  const { res } = context;
  const { slug } = context.params!;

  return await loadPageWithGlobal(
    async () => {
      const { trail } = await getTrailPage(slug);

      return {
        ...trail,
      };
    },
    { res },
  );
};

export default Page;
